var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeatStrokeRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9253 2L11.5939 2.65049C11.8925 2.9411 12.0419 3.08641 11.9893 3.20987C11.9367 3.33333 11.7255 3.33333 11.3031 3.33333H6.12915C3.48031 3.33333 1.33301 5.42267 1.33301 8C1.33301 8.99147 1.65079 9.9108 2.19267 10.6667",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07437 14.0007L4.40583 13.3502C4.10716 13.0595 3.95782 12.9143 4.01038 12.7908C4.06294 12.6673 4.27413 12.6673 4.69652 12.6673H9.87054C12.5193 12.6673 14.6667 10.578 14.6667 8.00065C14.6667 7.00918 14.3489 6.08987 13.807 5.33398",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatStrokeRounded);
export default __webpack_public_path__ + "static/media/repeat_stroke_rounded.5a3a61bb7196594a12ea935523d38b34.svg";
export { ForwardRef as ReactComponent };